import {IServiceListItem} from "app/bookings/new/types/newBooking.types";
import {
  IGroupWidgetService,
  IRecurringBookingSubset,
  IWeeklyScheduleSubset
} from "shared-services/recurring-booking-service/type";
import {IBooking, IServiceItem} from "app/app.types";
import DateUtilsService from "external-services/date-utils-service";
import {IMapPair, ISelectorListProps} from "app/bookings/new/RepeatBooking/types";
import {SECTION_ANY_ID, SECTION_ANY_NAME, ITableItem} from "shared-types/index";
import RecurringBookingService from 'shared-services/recurring-booking-service';

/** Populate booking template details */
export function makeBookingTemplate(bookingInfo: IBooking, sectionsLookup: any, serviceViewList: IServiceListItem[]) {

  const sectionDetails = RecurringBookingService.getSectionDetailsFromSectionLookup(bookingInfo.tables, sectionsLookup);

  /* todo add Unit tests */
  const bookingTemplateRequest: IRecurringBookingSubset = {
    time: DateUtilsService.DateToDateTimeString(bookingInfo.time),
    duration: bookingInfo.duration,
    numOfPeople: bookingInfo.people,
    sectionId: sectionsLookup[sectionDetails[0]?._id] ? sectionDetails[0]._id : SECTION_ANY_ID,
    sectionName: getSectionName(sectionDetails[0]?._id, sectionsLookup),
    serviceId: bookingInfo.serviceId,
    serviceName: serviceViewList.find((service) => service.service._id === bookingInfo.serviceId)?.name || '',
    tableIds: bookingInfo.tables.map(t => t._id),
  }

  return bookingTemplateRequest;
}

function getSectionName(sectionId: string, sectionsLookup: any): string {
  if (sectionId === SECTION_ANY_ID) {
    return SECTION_ANY_NAME
  } else {
    return sectionsLookup[sectionId] ? sectionsLookup[sectionId].name : SECTION_ANY_NAME;
  }
}

/** Populate service list */
export function getServiceOptions(serviceId: string, serviceList: IServiceListItem[]) {

  const serviceOptions: IMapPair[] = serviceList.filter((service) => !service.service.eventType).map(service => {
    return {
      name: service.name,
      value: (service.service as IServiceItem)._id
    }
  });

  const services: ISelectorListProps = {
    selectedOption: serviceId,
    listOfOptions: serviceOptions
  }

  return services;
}

/** Populate service list */
export function getWeeklyServiceOptions(serviceName: string, serviceList: IServiceListItem[]): ISelectorListProps {
  if (!serviceList.length) {
    return {
      selectedOption: '',
      listOfOptions: []
    }
  }
  let serviceId;
  const serviceOptions: IMapPair[] = serviceList.filter((service) => !service.service.eventType).map(service => {
    if (service.name === serviceName) {
      serviceId = service.service.id
    }
    return {
      name: service.name,
      value: (service.service as IGroupWidgetService).id
    }
  });
  if (!serviceId) {
    serviceId = serviceList[0].service.id;
  }
  const services: ISelectorListProps = {
    selectedOption: serviceId,
    listOfOptions: serviceOptions
  }

  return services;
}

/** Populate service list */
export function getServicesFromSchedule(schedule: IWeeklyScheduleSubset): IServiceListItem[] {
  return schedule.services.map((service, index) => {
    return {
      service: service,
      serviceIndex: index,
      name: service.name
    }
  });
}

/** Populate table list */
export function getTableOptions(tableList: ITableItem[], bookingInfo: IBooking, sectionsLookup: any) {

  if (!tableList) return null;

  const tableOptions: IMapPair[] = tableList.map(table => {
    return {
      value: table._id,
      name: `T${table.name} * C${table.capacity} ${sectionsLookup[table.sectionId].name}`
    }
  });

  const tables: ISelectorListProps = {
    listOfOptions: tableOptions,
    selectedOption: bookingInfo?.tables?.length ? bookingInfo.tables[0]._id : ""
  }

  return tables;
}
